import { Button } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ListLoader from '~/components/ListLoader';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import { PaymentSummarySubmitBtnProps } from '~/types/paymentTypes';

export default function PaymentSummaryWrapper({
  summary,
  totalFeesLabel,
  fees,
  submitBtnProps,
  isLoading,
  title,
  submitBtnLabel,
  topContent,
  enableTermsAndConditions = false,
}: {
  isLoading?: boolean;
  summary: React.ReactNode;
  totalFeesLabel: string;
  fees: string | null | React.ReactNode;
  submitBtnProps: PaymentSummarySubmitBtnProps;
  title: string;
  submitBtnLabel?: string;
  topContent?: React.ReactNode;
  enableTermsAndConditions?: boolean;
}) {
  const { t } = useTranslation('app');
  const dispatch = useAppDispatch();

  return (
    <div className="flex flex-col gap-3x w-full md:w-[40%]">
      <p className="text-title_3"> {title}</p>
      <div className=" flex flex-col gap-2x md:gap-3x element-center  border border-gray rounded-[8px]  p-2x md:p-3x w-full">
        {topContent}
        {isLoading ? (
          <ListLoader height={20} count={3} />
        ) : (
          <>
            <div className="flex flex-col bg-gray_light_1 rounded-[8px] px-2x md:px-3x  py-3x w-full ">
              {summary}
            </div>
            <div className="flex justify-between border-t border-t-gray pt-2x md:pt-3x w-full">
              <p className="text-title_4 ">{totalFeesLabel}</p>
              <p className="text-title_4 ">{fees}</p>
            </div>
          </>
        )}
        <div className="flex flex-col gap-3x w-full">
          <Button
            size="medium"
            variant="primary"
            className="w-full hidden md:flex"
            {...submitBtnProps}
          >
            {submitBtnLabel ?? t('pay')}
          </Button>
          {enableTermsAndConditions && (
            <p className="hidden text-center text-caption-1 text-gray__dark_1 md:block">
              <Trans
                i18nKey="termsAndConditions"
                t={t}
                components={{
                  tag: (
                    <button
                      className="text-title-5 text-blue hover:underline"
                      onClick={() => {
                        dispatch(openModal('termsAndConditionsModal'));
                      }}
                    />
                  ),
                }}
              />
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
